/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import * as vp from 'vopay';
import type { IQ11LoginResponse } from './useApi/usePostIQ11Login';

const { useSessionStorage } = vp.useStorage;

const useStorage = () => {
  const handlers = {
    useClientAccountStorage: () => useSessionStorage<vp.IQ11AuthorizationClientAccount | undefined>('ClientStorage'),
    useJWTStorage: wrapSessionStorage<string>('IQ11JWT'),
    useClientAccountPermissions: () => useSessionStorage<vp.IQ11Permissions | undefined>('IQ11Permissions'),
    useAccountLoginUserEmail: wrapSessionStorage<string>('IQ11AccountLoginName'),
  };
  const [clientAccount, storeClientAccount, clearClientAccount] = handlers.useClientAccountStorage();
  const [clientAccountPermissions, storeClientAccountPermissions, clearClientAccountPermissions] =
    handlers.useClientAccountPermissions();
  const [jwt, storeJWT, clearJWT] = handlers.useJWTStorage();
  const [loginUserEmail, storeLoginUserEmail, clearLoginUserEmail] = handlers.useAccountLoginUserEmail();

  return {
    login: {
      getIQ11UserLogin: () => ({ clientAccount, jwt, loginUserEmail, clientAccountPermissions }),
      storeIQ11UserLogin: (response: IQ11LoginResponse, LoginUserEmail: string) => {
        storeClientAccount(response.clientAccount);
        storeJWT(response.jwt);
        storeLoginUserEmail(LoginUserEmail);
        storeClientAccountPermissions(response.permissions);
      },
      clearIQ11UserLogin: () => {
        clearClientAccount();
        clearJWT();
        clearLoginUserEmail();
        clearClientAccountPermissions();
      },
    },
  };
};

function wrapSessionStorage<T extends string>(key: string): () => [T | '', (input: T) => void, () => void] {
  return () => {
    const [value, setValue, clearValue] = useSessionStorage<T | ''>(key, '');
    return [value || '', (v: T) => setValue(v), () => clearValue()];
  };
}

export default useStorage;
